import axiosClient from "./axiosClient";
import {Result} from "./types";
import {getTokenCookie} from "../libs";

export class MasterApi {
    config: any

    constructor() {
        const token = getTokenCookie()
        this.config = {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        }
    }
    getFaculty = async (): Promise<Result> => {
        return await axiosClient.get(`/master/faculty`);
    }
    getProdi = async (idFaculty: number): Promise<Result> => {
        return await axiosClient.get(`/master/prodi/${idFaculty}`)
    }
    getMemberType = async (): Promise<Result> => {
        return await axiosClient.get(`/master/memberType`)
    }
    getSubject = async (): Promise<Result> => {
        return await axiosClient.get(`/master/subject`)
    }
    getPapersType = async (): Promise<Result> => {
        return await axiosClient.get(`/master/papersType`,this.config)
    }
    getLecture = async (): Promise<Result> => {
        return await axiosClient.get(`/master/lecture`,this.config)
    }
}
